import { Star } from "lucide-react";
import { cn } from "@/lib/cn";

export function StarsRating({
  value,
  count,
  size = 16,
  className,
}: {
  value: number;
  count?: number;
  size?: number;
  className?: string;
}) {
  const full = Math.round(value);
  return (
    <span className={cn("inline-flex items-center gap-1", className)}>
      <span
        className="inline-flex"
        role="img"
        aria-label={`${value} out of 5 stars`}
      >
        {Array.from({ length: 5 }).map((_, i) => (
          <Star
            key={i}
            size={size}
            className={
              i < full
                ? "fill-calm-orange text-calm-orange-ink"
                : "fill-night-blue/10 text-night-blue/20"
            }
          />
        ))}
      </span>
      {typeof count === "number" && (
        <span className="text-xs font-medium text-night-blue/70">
          {value.toFixed(1)} ({count})
        </span>
      )}
    </span>
  );
}
